import Axios from 'axios';

export const getPortalInfo = () => Axios.get('accounts/getPortalInfo');

export const getAcceptTerms = () => Axios.get('accounts/profile/acceptTerms');

export const confirmAcceptTerms = () => Axios.post('accounts/profile/confirmAcceptTerms');

export const getConfiguration = () => Axios.get(`${window.location.origin}${window.location.pathname}config/config.json`);

export const logoff = (userId) => Axios.post('accounts/logoff', { UserId: userId });

export const checkElectronicSignatureByUserPassword = async (params) =>{
    const config = await getConfiguration();

   return Axios.post(`${config.data.AUTHORITY}/api/account/validatePassword`, params);
};

export const getTokenToRedirectExternal = async(params) => {
    const config = await getConfiguration();

    return Axios.post(`${config.data.AUTHORITY}/connect/token`, params);
};

